// Open tab on click
jQuery(document).ready(function ($) {
	
    /*$('.lectures-content .tab').on('click', function() {
		if ($(this).hasClass('active')) {
			$(this).children().last().removeClass('open');
			$(this).removeClass('active');
		} else {
			$(this).children().last().addClass('open');
			$(this).addClass('active');
		}
    });*/

	$('.lectures-content .tab-headline').on('click', function() {
		if ($(this).hasClass('active')) {
			$(this).next().removeClass('open');
			$(this).removeClass('active');
		} else {
			$(this).next().addClass('open');
			$(this).addClass('active');
		}
    });
  
});
